const blankDayTypeRequest = {
  dayTypeCode: '',
  fromDate:'',
  toDate: '',
  fromTime:'',
  toTime: '',
  status: 'U',
  myComment: '',
  statusComment: '',
};

export default blankDayTypeRequest;



// WEBPACK FOOTER //
// ./src/Components/DayType/utils/day-type-requests/blankDayTypeRequest.js